import { graphql, Link } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";

import DoNotMountComponent from "../../modules/DoNotMountComponent/DoNotMountComponent";
import LanguageSelector from "../../modules/LanguageSelector/LanguageSelector";
import CatchEmail from "../../modules/Organisms/CatchEmail/CatchEmail";
import { getSlugWithLang } from "../../modules/Shared/Utils/getSlugWithLang";
import { ISliceProps } from "../../types/thecookies";

type PropsFooter = ISliceProps<Queries.FooterQuery>;

export const Footer: React.FC<PropsFooter> = (props: PropsFooter) => {
  const { t } = useTranslation("global");
  if (!props.data.legals || props.data.legals.nodes.length < 1)
    return <DoNotMountComponent sms={"Footer sin legales"} log={props.data} />;

  const legalLinks = props.data.legals.nodes.map((node) => {
    return {
      slug: getSlugWithLang(
        `/legal/${node.slug}`,
        props.sliceContext?.language,
      ),
      name: node.name,
    };
  });

  return (
    <section
      className={"is-background-light o-capture-emails"}
      id={"subscription"}
    >
      <CatchEmail
        text={t("Nuestras pepitas de chocolate para mejorar tus ")}
        highlight={t("proyectos")}
        cta={t("Las quiero")}
      />
      <footer className={"o-footer"}>
        <div className={"c-footer"}>
          <div className={"footer__details"}>
            <p>
              {t(" © TheCookies Agency S.L. Todos los derechos reservados")}
            </p>
            <LanguageSelector />
          </div>
          <div className={"m-footer__legal"}>
            <a
              href="https://thecookies.notion.site/Ofertas-abiertas-f9330eaa423540039f09596d16afda56"
              target={"_blank"}
              rel={"noopener nofollow noreferrer"}
            >
              {t("Trabaja con nosotros")}
            </a>
            {legalLinks.map((legal, index) => {
              return (
                <a
                  className={"footer__link"}
                  key={index}
                  href={`${legal.slug}`}
                  title={`${legal.name}`}
                  aria-label={`${t("goto")} ${legal.name}`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  {legal.name}
                </a>
              );
            })}

            <Link to={`/servicios-digitalizacion/`}>
              {`${t("Kit Digital")}`}
            </Link>
            <button
              className={"footer__button-settings"}
              type="button"
              data-cc="show-preferencesModal"
            >
              {t("Configuración cookies")}
            </button>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Footer;

export const query = graphql`
  query Footer($language: String! = "es_es") {
    legals: allSanityLegal(filter: { language: { eq: $language } }) {
      nodes {
        name
        slug
      }
    }
  }
`;
